// import React from 'react';
// import '../styles/footer.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';


// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="footer-content">
//         <div className="footer-left">
//           <p>© 2025 Medicare Hospitals PLC. All rights reserved.</p>
//         </div>

//         <div className="footer-center">
//           <h2 style={{ fontSize: "16px", color: "white" }}>Follow us</h2>
//           <div className="footer-icons">
//             <ul>
//               <li><a href="https://dockyardsoftware.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a></li>
//               <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
//               <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
//               <li><a href="https://www.tiktok.com/@dockyard.software?_t=ZS-8yVMoDxdoSg&_r=1" target="_blank" rel="noopener noreferrer"><i className="fab fa-tiktok"></i></a></li>
//             </ul>
//           </div>
//         </div>

        
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import React from 'react';
import { createPortal } from 'react-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';

const FooterContent = () => {
  const year = new Date().getFullYear();

  const footerStyle = {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1400,
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    color: '#ffffff',
    borderTop: '1px solid rgba(255,255,255,0.12)',
    boxShadow: '0 -8px 30px rgba(0,0,0,0.4)',
  };

  const containerStyle = {
    maxWidth: 1120,
    margin: '0 auto',
    padding: '8px 16px',
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: 12,
  };

  const leftStyle = { display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'flex-start' };
  const centerStyle = { textAlign: 'center' };
  const rightStyle = { display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'flex-end' };
  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    background: 'rgba(255,255,255,0.08)',
    padding: '6px 10px',
    borderRadius: 8,
    color: '#fff',
    textDecoration: 'none',
  };

  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        <div style={leftStyle} />

        <div style={centerStyle}>
          <div style={{ fontSize: 12, fontWeight: 700 }}>Aura Meditation Kadawatha</div>
          <div style={{ fontSize: 9, opacity: 0.9 }}>© {year} All rights reserved</div>
        </div>

        <div style={rightStyle}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>Follow us:</span>
          <a
            href="https://web.facebook.com/people/Aura-Meditation-kadawatha/61568073879061/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Aura Meditation Facebook"
            style={badgeStyle}
          >
            <i className="fab fa-facebook-f" style={{ marginRight: 4 }} />
            <span>Facebook</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

const Footer = () => {
  if (typeof document === 'undefined') return <FooterContent />;
  return createPortal(<FooterContent />, document.body);
};

export default Footer;